export default {
  container: {
    marginBottom: 24
  },
  marginTop: {
    marginTop: 16
  },
  button: {
    marginTop: 16
  }
}
